/** Resolve a URL/data-URI da logo a partir das configurações de aparência. */
export function resolveLogoSrc(logoBase64?: string | null, logoUrl?: string | null): string | null {
  const b64 = logoBase64?.trim();
  if (b64) {
    return b64.startsWith('data:') ? b64 : `data:image/png;base64,${b64}`;
  }
  const url = logoUrl?.trim();
  return url || null;
}
